import { useState, useRef, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import './style.css'

const MenuInfo = ({ children }) => {
  const [show, setShow] = useState(false)
  const wrapperRef = useRef(null)
  const iconRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      setShow(false)
    }
    const handleClickOutside = (event) => {
      let hideOverlay = true
      ;[wrapperRef, iconRef].forEach((ref) => {
        if (ref.current && ref.current.contains(event.target)) {
          hideOverlay = false
        }
      })
      if (hideOverlay) {
        setShow(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleIconClick = () => {
    setShow(!show)
  }

  return (
    <OverlayTrigger
      trigger="manual"
      show={show}
      placement="bottom"
      overlay={
        <Tooltip id="tooltip-top">
          <div
            ref={wrapperRef}
            dangerouslySetInnerHTML={{ __html: children }}
          />
        </Tooltip>
      }
    >
      <span>
        {'\u2060'}
        <FontAwesomeIcon
          icon={faCircleInfo}
          className="menu-info"
          onClick={handleIconClick}
          ref={iconRef}
          style={{ cursor: 'pointer' }}
        />
      </span>
    </OverlayTrigger>
  )
}

export default MenuInfo
